import { localDateString } from "../../tasksCalendar/lib/calendarCodec";
import {
  localMonthEnd,
  localMonthStart,
} from "../../tasksCalendar/lib/calendarMonth";
import { isWorkOverdue, workKindLabel } from "./workLabels";

/**
 * Presentation adapter — maps Task due_date / Viewing scheduled_at to calendar
 * day keys without mutating API fields or statuses.
 */
export function workItemCalendarDay(item, kind) {
  if (!item) return null;
  const raw = kind === "viewing" ? item.scheduled_at : item.due_date;
  if (!raw) return null;
  const d = new Date(raw);
  if (Number.isNaN(d.getTime())) return null;
  return localDateString(d);
}

export function workItemCalendarKey(item, kind) {
  if (!item || item.id == null) return null;
  return `${kind}:${item.id}`;
}

export function toCalendarPresentation(item, kind) {
  const day = workItemCalendarDay(item, kind);
  return {
    key: workItemCalendarKey(item, kind),
    kind,
    id: item.id,
    day,
    title:
      kind === "viewing"
        ? `Перегляд #${item.id}`
        : item.title || `Задача #${item.id}`,
    status: item.status,
    kindLabel: workKindLabel(kind),
    overdue: isWorkOverdue(item, kind),
    raw: item,
  };
}

export function groupCalendarItemsByDay(items) {
  const map = new Map();
  for (const item of items) {
    if (!item?.day) continue;
    if (!map.has(item.day)) map.set(item.day, []);
    map.get(item.day).push(item);
  }
  return map;
}

export function companyMonthRangeParams(month, kind) {
  const start = localMonthStart(month);
  const end = localMonthEnd(month);
  if (kind === "viewing") {
    return {
      scheduled_after: start.toISOString(),
      scheduled_before: end.toISOString(),
    };
  }
  return {
    due_after: start.toISOString(),
    due_before: end.toISOString(),
  };
}
